import { createApi } from "@reduxjs/toolkit/query/react";
import { isDefined } from "@callveriq/utils/helper/common.helper";
import {
    LiveAssistTemplate,
    LiveConversationViolations,
} from "@callveriq/type/LiveConversation";
import axiosBaseQuery from "../axiosBaseQuery";
import { Template } from "@callveriq/type/Audit";
import { LiveCallStart } from "@callveriq/type/WebSocketNotification";

export enum CallEvent {
    CallStart = "start",
    IsCallActive = "active_calls",
    Transcript = "transcript",
    LiveAudit = "call_flow_template",
    CallEnd = "end",
}

export const liveConversationApiSlice = createApi({
    reducerPath: "templateApiSlice",
    baseQuery: axiosBaseQuery({
        transformResponse: (response) => response,
    }),
    endpoints: (builder) => ({
        getLiveAssistTemplates: builder.query<Template[], void>({
            query: () => "live_assist/templates/",
        }),
        getActiveTemplateById: builder.query<
            LiveAssistTemplate,
            { template_id: number; conversation_id: string } | null
        >({
            query: (payload) => `live_assist/template/${payload?.template_id}/`,
            transformResponse(res: LiveAssistTemplate) {
                if (isDefined(res.categories))
                    for (const category of res.categories) {
                        // Loop through the questions in each category
                        for (const question of category.questions) {
                            // Add the "is_covered_in_call" field and set it to false
                            question.is_covered_in_call = false;
                        }
                    }
                return res;
            },
        }),
        getActiveCallsByAgentId: builder.mutation<
            LiveCallStart["body"][],
            { agent_id: number }
        >({
            query: (payload) => ({
                url: "/live_assist/active_calls/",
                method: "POST",
                body: payload,
            }),
        }),
        getLiveViolations: builder.query<LiveConversationViolations, string>({
            queryFn: () => {
                return {
                    data: [],
                };
            },
        }),
    }),
});

export const {
    useGetLiveAssistTemplatesQuery,
    useGetActiveTemplateByIdQuery,
    useGetActiveCallsByAgentIdMutation,
    useGetLiveViolationsQuery,
} = liveConversationApiSlice;
